(function ($) {
	$(window).scroll(() =>
		$('header').toggleClass('is-sticky', $(document).scrollTop() > 210)
	).trigger('resize');
})(jQuery);
